import { Component } from '@angular/core';
import { NotifydialogData } from '../../_model/shared';
import { NgTemplateOutlet } from '@angular/common';
import { NgbModalRef } from '@ng-bootstrap/ng-bootstrap';


@Component({
    selector: 'notify-dialog',
    templateUrl: './notifydialog.component.html',
    styleUrls: ['notifydialog.component.scss'],
    imports: [NgTemplateOutlet]
})
export class NotifydialogComponent {

  dialogRef: NgbModalRef;
  public data: NotifydialogData

  constructor(
  ) {
  }

  ngOnInit(){
    // this.dialogRef..subscribe(res=>{
    //   if()
    // })

  }

}
